import { isNull } from 'lodash';

const randomTimeout = (time: $TSFixMe) => (time > 0 ? Math.floor(Math.random() * time) : 0);

export function createPoller(
    task: $TSFixMe,
    interval: $TSFixMe,
    { startImmediately = true, progressive = false, randomized = false } = {}
) {
    let timeoutId: $TSFixMe = null;
    let callCount = 0;

    // maxInterval allowing at least 4 back-off calls
    const maxInterval = interval * 16;
    let currentInterval = interval;

    const start = async () =>
        new Promise((resolve) => {
            if (callCount === 0) {
                let wait = window.setTimeout(
                    () => {
                        window.clearTimeout(wait);
                        // @ts-expect-error $TSFixMeError: Type 'null' is not assignable to type 'number'.
                        wait = null;
                        resolve(task());
                    },
                    startImmediately ? 0 : randomTimeout(interval)
                );
            } else {
                resolve(task());
            }
        })
            .then(() => {
                run();
            })
            .catch((err) => {
                run();
                throw err;
            });

    const stop = () => {
        if (!isNull(timeoutId)) {
            window.clearTimeout(timeoutId);
            timeoutId = null;
            callCount = 0;
            currentInterval = interval;
        }
    };

    const isRunning = () => !isNull(timeoutId);

    const run = () => {
        callCount++;
        currentInterval = progressive ? Math.min(currentInterval * 2, maxInterval) : currentInterval;

        const finalInterval = randomized ? randomTimeout(currentInterval) : currentInterval;
        timeoutId = window.setTimeout(start, finalInterval);
    };

    return { start, stop, isRunning };
}
